import React from 'react';
import { RoadmapCheckboxesToggleWrapper } from 'feature-toggle';
import Layout from './Layout';
import { RoadmapDescriptionLayoutProps } from './Layout/types';

export function RoadmapDescription(props: RoadmapDescriptionLayoutProps) {
  return (
    <RoadmapCheckboxesToggleWrapper>
      <Layout {...props} />
    </RoadmapCheckboxesToggleWrapper>
  );
}
